/* this may be repeated in several functions. It concatonates all the pieces for the needed
query to grab a character from the API
*/

export function buildComicDatabaseQuery(firstLetter,limit,offset){
    const hash = localStorage.getItem("marvelHash");
    const publicMarvelKey = "3a7ee881bddc680e47706a7a2d04a326";
    const timeStamp = "&ts=1";    
    const requestURL = "https://gateway.marvel.com:443/v1/public/comics?titleStartsWith=";
    const comicsDataQuery = requestURL + firstLetter + "&orderBy=title&limit=" + limit + "&offset="+ offset + "&apikey=" + publicMarvelKey + "&hash=" + hash + timeStamp;
    return comicsDataQuery;
}


// WEBPACK FOOTER //
// ./src/components/includes/buildComicDatabaseQuery.js